module.exports = __webpack_public_path__ + "static/media/aws-liveness.8c20ce05.svg";